import { Component, Inject, OnInit, ViewChild, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { Observable, Subject, Subscription } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';
import { ProcessListService } from 'src/services/process-list.service';
import { CandidateEditDialogComponent } from '../candidate-edit-dialog/candidate-edit-dialog.component';
import { ProcessListInterviewEvaluatedDialogComponent } from '../process-list-interview-evaluated-dialog/process-list-interview-evaluated-dialog.component';
import { ProcessListSelectionTestDialogComponent } from '../process-list-selection-test-dialog/process-list-selection-test-dialog.component';
import { ProcessListCandidatePointsDialogComponent } from '../process-list-candidate-points-dialog/process-list-candidate-points-dialog.component';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { map } from 'rxjs/operators';
import { PageEvent } from '@angular/material/paginator';
import { CandidateCommentDialogComponent } from '../candidate-comment-dialog/candidate-comment-dialog.component';
import { ProfessionalExperiencesViewsDialogComponent } from '../professional-experiences-views-dialog/professional-experiences-views-dialog.component';
import { GenericDialogComponent } from '../generic-dialog/generic-dialog.component';
import { OneSignalService } from 'src/services/onesignal.service';
import { ProcessListInterviewDialogComponent } from '../process-list-interview-dialog/process-list-interview-dialog.component';
import { ProcessListInterviewSessionDialogComponent } from '../process-list-interview-session-dialog/process-list-interview-session-dialog.component';
import { SelectionTestDialogComponent } from '../selection-test-dialog/selection-test-dialog.component';
import { ProcessListMultipleSelectionTestDialogComponent } from '../process-list-multiple-selection-test-dialog/process-list-multiple-selection-test-dialog.component';
import { CommunicationService } from 'src/services/communication.service';

@Component({
  selector: 'app-create-process-list',
  templateUrl: './create-process-list.component.html',
  styleUrls: ['./create-process-list.component.scss']
})
export class CreateProcessListComponent implements OnInit {

  candidateMode: string = 'default';
  mediaEndpoint: string = 'https://app2.colloca.com.br/api';
  public selectionTests: Array<any> = [];
  candidates: Array<any> = [];
  @ViewChild('selectCandidatesForTest', { static: false }) candidatesForTest: MatSelectionList;
  @ViewChild('candidatesForHire', { static: false }) candidatesForHire: MatSelectionList;
  submiting: boolean = false;
  @Input() currentProcessList: any = null;
  processListId: string = null;
  processListStatus: string;
  isSmallScreen$: Observable<boolean>;
  totalLeads: number;
  candidatesHired: boolean = false;
  candidatesCountByProcessListId: { [key: number]: number } = {};
  candidatesCountByProcessListIdNotHired: { [key: number]: number } = {};
  qtdProcessList: number;
  @Output() hireCandidatesEvent = new EventEmitter<void>();
  alertInterview: Record<number, boolean> = {};
  alertTestview: Record<number, boolean> = {};
  alertFitview: boolean = true;
  areAllCandidatesSelected = false;

  constructor(
    fb: FormBuilder,
    private http: HttpService,
    private errorReport: ErrorReportService,
    private snackbar: MatSnackBar,
    private dialog: MatDialog,
    private processList: ProcessListService,
    private breakpoint: BreakpointObserver,
    private oneSignalService: OneSignalService,
    private communicationService: CommunicationService,
  ) {

  }

  ngOnInit(): void {

    this.currentProcessList = this.currentProcessList;
    this.processListStatus = this.currentProcessList.status;
    this.processListId = this.currentProcessList.id;
    this.qtdProcessList = this.currentProcessList.qtd;

    this.isSmallScreen$ = this.breakpoint
      .observe([Breakpoints.XSmall, Breakpoints.HandsetPortrait])
      .pipe(
        map(state => {
          return state.matches
        })
      )

    this.http.get(`selection_test`)
      .subscribe(
        (result: any) => {
          this.selectionTests = result;
        },
        err => this.errorReport.showMessage(err)
      )

    const subject = new Subject();
    subject.subscribe(
      (result: any) => {

        const { trigger } = result;
        this.submiting = (trigger === 'pre');

      }
    )

    this.http.setLoadingIndicator(subject)
    this.getProcessListLead();
    this.getTotalProcessListLead();
    this.processList.loadCandidates(this.processListId);

    //carrega leads quando adiciona ao processo seletivo
    this.processList.getEvent().subscribe(
      {
        next: (value: any) => {

          if (value == 'save') {
            this.getProcessListLead();
            this.getTotalProcessListLead();
            this.processList.loadCandidates(this.processListId);
          }
        }
      }
    )

    setInterval(() => {
      this.notifications();
    }, 100);

    this.oneSignalService.alerts$.subscribe(alerts => {
      if(alerts){
        //console.log('alerta');
        this.getProcessListLead();
      }
    });
    

  }

  private getTotalProcessListLead() {

    this.http.get('process_list:total_lead', { processList: this.processListId })
      .subscribe(
        (result: any) => this.totalLeads = (result.data.records as number),
        err => this.errorReport.showMessage(err)
      )

  }

  private getProcessListLead(params = null) {

    const data = {
      processList: this.processListId,
      ...params
    };

    this.http.get('process_list:lead', data)
      .subscribe(
        (result: any) => {
          
          this.candidates = result.data.map((item) => {
            const keywordParts = item.keywords ? this.parseJson(item.keywords) : null;
            let keywords = null;
            this.candidates = result.data
            //console.log('candidatos', this.candidates);
            const hiredCandidatesCount = this.candidates.filter(candidate => candidate.candidateStatus === 'hired').length;
            this.candidatesCountByProcessListId[this.processListId] = hiredCandidatesCount;
            const nothiredCandidatesCount = this.candidates.filter(candidate => candidate.candidateStatus !== 'hired').length;
            this.candidatesCountByProcessListIdNotHired[this.processListId] = nothiredCandidatesCount;

            if (keywordParts)
              keywords = keywordParts.join(', ')

            this.alertInterview[item.id] = item.accept_view_interview >= 1 ? true : false;
            localStorage.setItem('interviewViewed_' + item.id, item.accept_view_interview == 0 ? 'true':'false');
            
            this.alertTestview[item.id] = item.accept_view_test >= 1 ? true : false;
            localStorage.setItem('testviewViewed_' + item.id, item.accept_view_test == 0 ? 'true':'false');


            return {
              ...item,
              keywords
            }
          })

        },
        err => this.errorReport.showMessage(err)
      )

  }

  finish() {

    const data = { id: this.processListId };
    this.http.save('process_list:finish', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Processo concluído com sucesso!', 'OK', { duration: 3000 })
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  openProfessionalExperiences(candidate: any) {

    const options = {
      data: { candidate },
      width: '800px',

    }

    this.dialog.open(
      ProfessionalExperiencesViewsDialogComponent,
      options
    )

  }

  openCandidateComment(lead) {

    const data = {
      candidate: { id: lead.id },
      processList: { id: this.processListId }
    };

    this.dialog.open(CandidateCommentDialogComponent,
      {
        width: '600px',
        disableClose: true,
        data: data
      }
    );

  }

  deleteLead(lead) {

    if (!confirm(`Deseja realmente remover o candidato ${lead.firstname.toUpperCase()} desse processo seletivo`))
      return;

    const data = { processList: this.processListId, lead: lead.id };
    this.http.delete('process_list:lead', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.getProcessListLead();
            this.processList.removeFrom(lead, this.processListId);
            this.processList.getEvent().emit('remove');
            this.hireCandidatesEvent.emit();
          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  deleteInterview(interview) {

    if (!confirm(`Deseja realmente deletar essa entrevista desse processo seletivo`))
      return;

    const data = { id: interview.id };
    this.http.delete('process_list:interview', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK')
            this.getProcessListLead();
        },
        err => this.errorReport.showMessage(err)
      )

  }

  openInterviewEvaluated(candidate) {

    this.alertInterview[candidate.id] = false;
    localStorage.setItem('interviewViewed_' + candidate.id, 'true');

    const options = {
      width: '900px',
      disableClose: true,
      data: {
        processList: this.currentProcessList,
        candidate
      }
    }
    this.dialog.open(ProcessListInterviewEvaluatedDialogComponent, options)
    .afterClosed()
      .subscribe((result) => {
        if (result)
          this.getProcessListLead();
      });

  }

  openCandidate(candidate) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        candidate,
        processListId: this.processListId,
        readOnly: true,
        keywordsSearch: {
          params: candidate.keywords ? candidate.keywords.split(',') : []
        }
      }
    }

    this.dialog.open(CandidateEditDialogComponent, options);

  }

  openSelectionTest(candidate) {

    this.alertTestview[candidate.id] = false;
    localStorage.setItem('testviewViewed_' + candidate.id, 'true');

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processListId: this.processListId,
        candidateId: candidate.id,
        processList: this.currentProcessList,
      }
    }
    this.dialog.open(ProcessListSelectionTestDialogComponent, options)
      .afterClosed()
      .subscribe(
        () => this.getProcessListLead()
      );

  }

  openQuestionResponses(candidate, showResponses = false) {

    const options = {
      width: '800px',
      disableClose: true,
      data: {
        processListId: this.processListId,
        candidateId: candidate.id,
        showResponses
      }
    }
    this.dialog.open(ProcessListSelectionTestDialogComponent, options);

  }

  toggleSelectCandidates() {
    if (this.areAllCandidatesSelected) {
      this.deselectAllCandidates();
    } else {
      this.selectAllCandidates();
    }
    this.areAllCandidatesSelected = !this.areAllCandidatesSelected; // Alterna o estado
  }

  selectAllCandidates() {
    this.candidatesForTest.selectAll();
  }

  deselectAllCandidates() {
    this.candidatesForTest.deselectAll();
  }

  hireCandidates() {

    if (!confirm('Deseja contratar os candidatos selecionados?'))
      return;

    const candidatesId = this.candidatesForHire.selectedOptions.selected.map(selected => selected.value);
    const data = {
      candidates: JSON.stringify(candidatesId),
      processList: this.processListId
    }

    this.http.save('process_list:hire', data)
      .subscribe(
        (result: any) => {
          if (result.type === 'OK') {
            this.snackbar.open('Candidatos contratado com sucesso!', 'OK', { duration: 3000 });
            this.candidateMode = 'default';
            this.getProcessListLead();
            this.candidatesHired = true;
            this.hireCandidatesEvent.emit();

            this.http.save('onsignal:getUser', {leads: { lead_ids: candidatesId }})
              .subscribe(
                (result: any) => {
                  if (result.type === 'OK') {
                    const signatureIds = result.data.map((item: any) => item.signature_id); // Extrai os signature_ids
                    //console.log('assinaturas', signatureIds);
                    const notification_for_all = null;
                    const title = 'Parabéns !!!';
                    const fullname = null;
                    const message = this.oneSignalService.listMessage(2, fullname, this.currentProcessList.name );
                    
                    // Envia os dados para a função do backend que lida com as notificações
                    this.oneSignalService.sendNotification(signatureIds, title, message, notification_for_all)
                    .subscribe(
                      (result: any) => {
                        if (result.type === 'OK') {
                          this.oneSignalService.listNotification();
                        } else {
                          console.error('Erro ao enviar notificação para o candidato contratado');
                        }
                      },
                      err => {
                        console.error('Erro ao enviar notificação ao candidato contratado', err);
                        this.errorReport.showMessage(err);
                      }
                    );
                  } else {
                    console.error('Erro ao obter dados para o envio da notificação');
                  }
                },
                err => this.errorReport.showMessage(err)
              )

          }
        },
        err => this.errorReport.showMessage(err)
      )

  }

  finishProcess() {

    // if(!this.candidatesHired) {
    //   if(confirm('Deseja contratar alguns candidatos antes de finalizar esse processo seletivo?')) {
    //     this.candidateMode = 'contract';
    //     return;
    //   }
    // }

    let options = {};

    let icon = 'help';
    let icon_class = 'font-icon';
    let message = '';
    let message2 = '';
    let buttons = [];

    const vagasRestantes = this.qtdProcessList - this.candidatesCountByProcessListId[this.processListId];
    message = `Tem certeza que deseja encerrar o processo seletivo?`;

    if (vagasRestantes >= 1) {

      message2 = `ainda há ${vagasRestantes} vaga(s) em aberto.`;
      if (this.candidatesCountByProcessListIdNotHired[this.processListId] >= 1) {
        buttons = [
          { name: 'Encerrar Processo', value: 1, class: 'primary' },
          { name: 'Contratar', value: 2, class: 'success' },
          { name: 'Cancelar', value: false, class: 'danger' }
        ];
      } else {
        buttons = [
          { name: 'Encerrar Processo', value: 1, class: 'primary' },
          { name: 'Cancelar', value: false, class: 'danger' }
        ];
      }

    } else {
      buttons = [
        { name: 'Encerrar Processo', value: 1, class: 'primary' },
        { name: 'Cancelar', value: false, class: 'danger' }
      ];
    }

    options = {
      disableClose: true,
      data: {
        icon,
        icon_class,
        message,
        message2,
        buttons
      }
    };

    this.dialog.open(GenericDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result == 1) {
            const data = {
              id: this.processListId
            }

            this.http.save('process_list:conclude', data)
              .subscribe(
                (result: any) => {

                  if (result.type === 'OK') {
                    this.snackbar.open('Processo Encerrado com sucesso!', 'OK', { duration: 3000 });
                    window.location.reload();
                  }
                },
                err => this.errorReport.showMessage(err)
              )

          } else if (result == 2) {
            this.candidateMode = 'contract';
            return;
          } else {
            return;
          }

        }
      );


  }

  openPoints(lead) {

    const data = {
      candidate: { id: lead.id, score: lead.score, points: lead.points },
      processList: { id: this.processListId }
    };
    const options = {
      disableClose: true,
      width: '800px',
      data: data
    }

    this.dialog.open(ProcessListCandidatePointsDialogComponent, options)
      .afterClosed()
      .subscribe((result) => {
        if (result)
          this.getProcessListLead();
      });

  }

  close() {
    this.processList.clear(this.processListId);
  }

  pageEvent(args: PageEvent) {

    const { pageIndex, pageSize } = args;
    this.getProcessListLead({ pageIndex, limit: pageSize });

  }

  parseJson(json: string) {
    return JSON.parse(json);
  }

  snackMessage(message:string){
    if(message){
      this.snackbar.open('Palavras Chaves: '+message, 'OK', { duration: 3000 });
    }else{
      this.snackbar.open('Nenhuma palavra chave encontrada', 'OK', { duration: 3000 });
    }
  }

  openNewTest() {

    const options = {
      disableClose: true,
      width: '800px',
      data: {}
    }
    this.dialog.open(SelectionTestDialogComponent, options)

  }

  openInterview() {

    const options = {
      width: '900px',
      disableClose: true,
      data: {
        processListId: this.processListId,
        currentProcessList: this.currentProcessList
      }
    }
    this.dialog.open(ProcessListInterviewDialogComponent, options);

  }

  openInterviewSession() {

    const options = {
      disableClose: true,
      width: '900px',
      data: {
        processListId: this.processListId,
        processList: this.currentProcessList
      }
    }
    this.dialog.open(ProcessListInterviewSessionDialogComponent, options)

  }

  notifications() {
    
    if (this.candidates && this.candidates.length > 0) {
      this.candidates.forEach(candidate => {
        
        const interviewNotif = localStorage.getItem('interviewViewed_' + candidate.id);
        if (interviewNotif == 'true') {
          this.alertInterview[candidate.id] = false; // Já foi visualizado, não exibe notificação
        }

        const testviewNotif = localStorage.getItem('testviewViewed_' + candidate.id);
        if (testviewNotif == 'true') {
          this.alertTestview[candidate.id] = false; // Já foi visualizado, não exibe notificação
        }
  
        const fitviewNotif = localStorage.getItem('fitviewViewed_' + candidate.id);
        if (fitviewNotif == 'true') {
          this.alertFitview = false; // Já foi visualizado, não exibe notificação
        }
  
      });
    }
  
  }

  openMultipleSelectionTest() {

    const candidatesId = this.candidatesForTest.selectedOptions.selected.map(selected => selected.value);
    const options = {
      disableClose: true,
      width: '800px',
      data: {
        processListId: this.processListId,
        candidatesId,
        processList: this.currentProcessList
      }
    };
    this.dialog.open(ProcessListMultipleSelectionTestDialogComponent, options)
      .afterClosed()
      .subscribe(
        result => {
          if (result)
            this.candidateMode = 'default'
        }
      )

  }

}
